export class RaffleTicket {

  raffleTicketId: number;
  raffleId: number;
  userId: number;
  rafflePaymentId: number;
  ticketNumber: number;
  timestamp: string;
  guess: number;
  guessDecimal: number;
  tier: number;
  contactEmail: string;

  private _hasGuess: boolean;
  get hasGuess() { return this._hasGuess; }

  public constructor(init?: Partial<RaffleTicket>) {
    Object.assign(this, init);
    this._hasGuess = this.guess > 0 || this.guessDecimal > 0;
  }
}


export class BearerTicket{
  
  salesPerson: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  name: string;
  email: string;
  orderNo: string;
  timestamp: string;
  ticketNo: number;
  tier: string;
  status: string;
  phone: string;
  rsu: string = "Online";
  paid: number;
  drawDate: string;
  license: string;
  location: string;

  public constructor(init?: Partial<BearerTicket>) {
    Object.assign(this, init);
  }
}